export default "__VITE_ASSET__D1yMuqwc__"